// extracted by mini-css-extract-plugin
export default {"tableRow":"UserList_tableRow__b2B11","tableCell":"UserList_tableCell__Tns8s","ant-drawer-body":"UserList_ant-drawer-body__ebk16"};